const megaMenu = {
  /**
   * Create mega menus
   *
   * @param {HTMLElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;
    this.dropdownTriggers = Array.prototype.slice.call(
      this.node.querySelectorAll('.navigation__link.has-dropdown'),
    );
    this.megaMenus = Array.prototype.slice.call(
      this.node.querySelectorAll('.mega-dropdown'),
    );

    this.createEventListeners();
  },

  createEventListeners() {
    document.body.addEventListener('click', (e) => {
      if (e.target.closest('.mega-dropdown') || e.target.closest('[aria-expanded="true"]')) {
        return;
      }

      this.closeMenus();
    });

    const html = document.querySelector('html');
    const isTouch = html.classList.contains('touchevents');

    this.dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        if (this.hasMegaMenuActive()) {
          e.preventDefault();
          e.stopPropagation();

          if (isTouch) {
            this.toggleMenu(e.currentTarget);
          } else {
            window.location = e.currentTarget.href;
          }
        }
      });

      if (!isTouch) {
        trigger.addEventListener('mouseenter', (e) => {
          if (this.hasMegaMenuActive()) {
            this.toggleMenu(e.currentTarget, true);
          }
        });

        trigger.addEventListener('mouseleave', () => {
          setTimeout(() => {
            this.closeMenus();
          }, 10);
        });
      }
    });

    this.megaMenus.forEach((megaMenuElement) => {
      if (!isTouch) {
        megaMenuElement.addEventListener('mouseleave', () => {
          this.closeMenus();
        });
      }
    });
  },

  hasMegaMenuActive() {
    return !(!!this.node.querySelector('.navigation > .collapse.show') && window.innerWidth < 992);
  },

  toggleMenu(trigger, force = null) {
    const triggerId = trigger.getAttribute('data-href');
    const menu = this.node.querySelector(`.mega-dropdown[aria-labelledby="${triggerId}"]`);
    const images = Array.prototype.slice.call(menu.querySelectorAll('img[data-src]'));
    const enableMenu = (force !== null && force) || !menu.classList.contains('is-open');

    images.forEach((image) => {
      image.src = image.getAttribute('data-src');
    });

    if (enableMenu) {
      menu.classList.add('is-open');
    } else {
      menu.classList.remove('is-open');
    }

    trigger.setAttribute('aria-expanded', menu.classList.contains('.is-open') ? 'true' : 'false');
  },

  closeMenus() {
    const dropdowns = Array.prototype.slice.call(
      this.node.querySelectorAll('.mega-dropdown.is-open'),
    );

    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('is-open');
    });
  },
};

export default () => {
  // You should implement this in your own code
  megaMenu.create(
    document.querySelector('body'),
  );
};
